import { ModalidadeArrecadacaoDto } from "src/app/pagamento/models/modalidade-arrecadacao-dto";

export const MODALIDADE_ARRECADACAO_DTO: ModalidadeArrecadacaoDto[] = [
  {
    "codigo": 3,
    "descricao": "AUTO-ATENDIMENTO"
  },
  {
    "codigo": 19,
    "descricao": "AUTO-ATENDIMENTO CORRESPONDENTE BANCARIO"
  },
  {
    "codigo": 14,
    "descricao": "DÉBITO AUTOMATICO"
  },
  {
    "codigo": 16,
    "descricao": "DÉBITO CONTA CORRENTE ON LINE AGENTE ARRECADADOR"
  },
  {
    "codigo": 15,
    "descricao": "DÉBITO EM CONTA CORRENTE ON LINE SISCOMEX"
  },
  {
    "codigo": 21,
    "descricao": "DÉBITO EM CONTA CORRENTE ONLINE PRÉ-AUTORIZADO"
  },
  {
    "codigo": 1,
    "descricao": "GUICHÊ DE CAIXA"
  },
  {
    "codigo": 18,
    "descricao": "GUICHÊ DE CAIXA CORRESPONDENTE BANCARIO"
  },
  {
    "codigo": 13,
    "descricao": "MENSAGERIA SPB"
  },
  {
    "codigo": 17,
    "descricao": "PIX"
  },
  {
    "codigo": 12,
    "descricao": "REGISTRO CONTÁBIL SIAFI"
  },
  {
    "codigo": 20,
    "descricao": "RETENÇÃO"
  }
];